export default function FlexAlignCenter({ children, className = '', ...rest }) {
  return (
    <div className={`d-flex align-items-center ${className}`} {...rest}>
      {children}
    </div>
  )
}
